import React from 'react'
import { Box, CircularProgress, Typography } from '@mui/material'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { DateRangePicker } from '@mui/x-date-pickers-pro/DateRangePicker'
import dayjs from 'dayjs'
import AnnouncementContent from '@/src/components/announcement-content'
import { getAnnouncementProps } from '..'

interface ListContainerProps {
  showDatePicker: boolean
  loading: boolean
  fromValue: string
  toValue: string
  currPage: number
  handleDate: (val: any) => void
  announcementData: any
  handlePageChange: (val: number) => void
  handleAnnouncement: (data: getAnnouncementProps) => void
}

const ListContainer = ({
  showDatePicker,
  handleDate,
  fromValue,
  toValue,
  loading,
  announcementData,
  handlePageChange,
  currPage,
  handleAnnouncement
}: ListContainerProps) => {
  return (
    <div className="w-full pb-[2.125rem] flex justify-center">
      <div className="flex justify-between w-full flex-col">
        {showDatePicker && (
          <div
            className={`flex justify-end ${
              showDatePicker ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-[-100%]'
            } transition-opacity transition-transform duration-2000`}
          >
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DateRangePicker
                className="w-60"
                onChange={handleDate}
                value={[dayjs(fromValue), dayjs(toValue)]}
                localeText={{ start: 'Check-in', end: 'Check-out' }}
              />
            </LocalizationProvider>
          </div>
        )}
        <div>
          {loading ? (
            <div className="w-full h-[200px] flex flex-col justify-center items-center">
              <CircularProgress />
            </div>
          ) : (
            <>
              {Object.keys(announcementData?.results || {}).length ? (
                <AnnouncementContent
                  handlePageChange={handlePageChange}
                  announcements={announcementData}
                  currPage={currPage}
                  handleAnnouncement={handleAnnouncement}
                />
              ) : (
                <Box className=" w-full h-32 flex items-center">
                  <Typography variant="body1" color="text.secondary">
                    Your filters have resulted in no items found. Please try adjusting your filters
                    or resetting them to view more items.
                  </Typography>
                </Box>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default ListContainer
